import { Draw } from 'ol/interaction';
import { Circle, Fill, Stroke, Style } from 'ol/style.js';
import { MultiPoint } from 'ol/geom';
import { Polygon } from 'ol/geom.js';
import { getElement } from '@Utils/Elements.js';
import { nanoid } from 'nanoid';
import { simplifyFeature } from '@Utils/FeatureUtils.js';
import { isClosed } from '@Utils/Coordinates.js';
import * as Utils  from '@Utils/Math.js';

let shiftKeyPressed = false;
document.addEventListener('keydown', (e) => {
	shiftKeyPressed = e.shiftKey;
});
document.addEventListener('keyup', (e) => {
	shiftKeyPressed = e.shiftKey;
});
export default class DrawElement extends Draw {
	element;
	holeId;
	constructor(elementName, source, props) {
		let holeId = props ? props.holeId : null;
		let courseId = props ? props.courseId : null;
		let simplify = true
		let element = getElement(elementName);
		let constraints = element.constraints ?? {}
		super({
			source: source,
			type: element.tooltype,
			maxPoints: constraints.maxPoints,
			freehand: false,
			style: [
				new Style({
					fill: new Fill({
						color: 'rgba(255, 255, 255, 0.1)'
					}),
					stroke: new Stroke({
						color: 'rgba(255, 255, 255, 0.4)',
						width: 2
					})
				}),
				new Style({
					geometry: function (feature) {
						let g = feature.getGeometry();
						if (Array.isArray(g.getCoordinates()[0])) {
							return new MultiPoint(g.getCoordinates()[0]);
						}
						return new MultiPoint(g.getCoordinates());
					},
					image: new Circle({
						radius: 3,
						fill: new Fill({
							color: 'white'
						}),
						stroke: new Stroke({
							color: 'rgba(255,255,255,0.5)',
							width: 2
						})
					})
				}),
				new Style({
					geometry: function (feature) {
						let g = feature.getGeometry();
						if (Array.isArray(g.getCoordinates()[0])) {
							return new MultiPoint([g.getCoordinates()[0][0]]);
						}
						return new MultiPoint([g.getCoordinates()[0]]);
					},
					image: new Circle({
						radius: 5,
						fill: new Fill({
							color: 'rgba(49,171,37,1)'
						}),
						stroke: new Stroke({
							color: 'rgba(49,171,37,0.5)',
							width: 2
						})
					})
				})
			]
		});
		this.holeId = holeId;
		this.courseId = courseId;
		this.on(
			'drawstart',
			function (evt) {
				evt.feature.set('unfinished', true);
				evt.feature.set('elementName', element.name);
				evt.feature.set('uid', nanoid())
				for (let key in props) {
					evt.feature.set(key, props[key]);
				}
			}.bind(this)
		);
		this.on(
			'drawend',
			function (evt) {
				if (this._modifyFeature) {
					let props = this._modifyFeature.getProperties();
					delete props.geometry
					evt.feature.setProperties(props, true);
					this._modifyFeature = null
					this._modifyFeatureSource = null
				}
				evt.feature.unset('unfinished');
				let coords = evt.feature.getGeometry().getCoordinates();
				if (element.tooltype == 'Polygon') {
					coords = coords[0]
				}
				if (simplify && shiftKeyPressed || simplify && coords.length > 50) {
					simplifyFeature(evt.feature);
				}
				let placeover = evt.feature.get('placeabove')
				let index = element.zIndex
				if (placeover) {
					let el = getElement(placeover)
					index = el.zIndex + 1
				}
				evt.feature.set('order', index);
				if (element.tooltype == 'Polygon') {
					if (!isClosed(evt.feature.getGeometry().getCoordinates())) {
						let coords = evt.feature.getGeometry().getCoordinates()[0];
						coords.push(coords[0]);
						evt.feature.setGeometry(new Polygon([coords]));
					}
				} else if (element.tooltype == 'LineString') {

				} else if (element.name.includes('tree') || element.name.includes('bush')) {
					//let randomTree = Utils.getRandomInt(1, 5)
					let randomSize = Utils.getRandomInt(20, 30);
					if (props['treeSize'] === 'small') {
						randomSize = Utils.getRandomInt(5, 10);
					}
					evt.feature.unset('tresSize');
					let randomRotation = Utils.getRandomInt(0, 359);
					evt.feature.set('textureSize', randomSize);
					evt.feature.set('textureRotation', randomRotation);
					if(props.textureRef) {
						evt.feature.set('textureRef', props.textureRef);
					} else if (element.name.includes('bush')) {	
						evt.feature.set('textureRef', 'bush' + 2);
					} else {
						evt.feature.set('textureRef', 'tree' + 2);
					}
					
				} else if (element.name.includes('icon')) {
					if (props.iconName) {
						evt.feature.set('iconName', props.iconName);
					}
				}
			}.bind(this)
		);
	}
}
